class IdleTimer {
    constructor({ timeout, onTimeout, onExpired }) {
        this.timeout = timeout;
        this.onTimeout = onTimeout;

        const expiredTime = parseInt(localStorage.getItem("_expiredTime"), 10) || 0;
        if (expiredTime > 0 && expiredTime < Date.now()) {
            console.log('Session expired immediately due to stored expired time');
            onExpired();
            return;
        }

        this.eventHandler = this.updateExpiredTime.bind(this);
        this.tracker();
        this.startInterval();
    }

    startInterval() {
        this.updateExpiredTime();

        this.interval = setInterval(() => {
            const expiredTime = parseInt(localStorage.getItem("_expiredTime"), 10) || 0;
            if (expiredTime < Date.now()) {
                console.log('Session timeout reached');
                if (this.onTimeout) {
                    try {
                        this.onTimeout();
                    } catch (error) {
                        console.error('Error in onTimeout callback:', error);
                    }
                    this.cleanUp();
                }
            }
        }, 1000);
    }

    updateExpiredTime() {
        if (this.timeoutTracker) {
            clearTimeout(this.timeoutTracker);
        }

        this.timeoutTracker = setTimeout(() => {
            const newExpiredTime = Date.now() + this.timeout * 1000;
            console.log(`Setting new expired time: ${newExpiredTime}`);
            localStorage.setItem("_expiredTime", newExpiredTime);
        }, 300);
    }

    tracker() {
        window.addEventListener("mousemove", this.eventHandler);
        window.addEventListener("scroll", this.eventHandler);
        window.addEventListener("keydown", this.eventHandler);
    }

    cleanUp() {
        console.log('Cleaning up timer');
        localStorage.removeItem("_expiredTime");
        clearInterval(this.interval);
        window.removeEventListener("mousemove", this.eventHandler);
        window.removeEventListener("scroll", this.eventHandler);
        window.removeEventListener("keydown", this.eventHandler);
    }
}

export default IdleTimer;
